var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnceintes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.98 65.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#e6007e;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill:#e6007e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "enceinte"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.8,14.61A29.8,29.8,0,0,0,1,33,32,32,0,0,0,55.61,55.61a32,32,0,0,0,0-45.24h0A31.79,31.79,0,0,0,33,1a29.47,29.47,0,0,0-17.9,5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.53,11.62a1.57,1.57,0,1,0-1.11-.46A1.57,1.57,0,0,0,10.53,11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44,10.9H22a3.69,3.69,0,0,0-3.68,3.69V48.45a3.69,3.69,0,0,0,2.94,3.61v3h4.42V52.13H40.35v2.94h4.42v-3a3.69,3.69,0,0,0,2.94-3.61V14.59A3.69,3.69,0,0,0,44,10.9ZM24.16,53.6H22.68V52.13h1.48Zm19.14,0H41.82V52.13H43.3Zm2.94-5.15A2.21,2.21,0,0,1,44,50.66H22a2.21,2.21,0,0,1-2.21-2.21V14.59A2.21,2.21,0,0,1,22,12.38H44a2.21,2.21,0,0,1,2.21,2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33,25.63A11.78,11.78,0,1,0,44.77,37.41,11.77,11.77,0,0,0,33,25.63Zm0,22.08A10.31,10.31,0,1,1,43.3,37.41,10.31,10.31,0,0,1,33,47.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33,28.57a8.84,8.84,0,1,0,8.83,8.84A8.83,8.83,0,0,0,33,28.57Zm0,16.2a7.37,7.37,0,1,1,7.36-7.36A7.36,7.36,0,0,1,33,44.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33,13.85A5.16,5.16,0,1,0,38.14,19,5.15,5.15,0,0,0,33,13.85Zm0,8.83A3.68,3.68,0,1,1,36.67,19,3.68,3.68,0,0,1,33,22.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33,16.79A2.21,2.21,0,1,0,35.2,19,2.21,2.21,0,0,0,33,16.79Zm0,2.95a.74.74,0,1,1,.74-.74A.74.74,0,0,1,33,19.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21.21,
    y: 13.85,
    width: 1.47,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 43.3,
    y: 13.85,
    width: 1.47,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21.21,
    y: 47.71,
    width: 1.47,
    height: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 43.3,
    y: 47.71,
    width: 1.47,
    height: 1.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33,33.73a3.68,3.68,0,1,0,3.68,3.68A3.68,3.68,0,0,0,33,33.73Zm0,5.89a2.21,2.21,0,1,1,2.21-2.21A2.21,2.21,0,0,1,33,39.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.32,36.67H12.38a.74.74,0,1,0,0,1.47h2.94a.74.74,0,1,0,0-1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.84,31.73l-2.21-2.21a.74.74,0,0,0-1,0,.76.76,0,0,0,0,1l2.21,2.2a.74.74,0,0,0,1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.82,42a.72.72,0,0,0-1,0l-2.21,2.21a.74.74,0,0,0,0,1,.75.75,0,0,0,1,0v0l2.21-2.21A.73.73,0,0,0,15.82,42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.6,36.67H50.66a.74.74,0,1,0,0,1.47H53.6a.74.74,0,1,0,0-1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.37,29.52a.74.74,0,0,0-1,0l-2.21,2.21A.74.74,0,0,0,50.66,33a.74.74,0,0,0,.52-.22l2.21-2.2A.75.75,0,0,0,53.37,29.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.39,44.25,51.18,42a.74.74,0,0,0-1,1l2.21,2.21a.74.74,0,0,0,1-1Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnceintes);
export default __webpack_public_path__ + "static/media/enceintes.c5d0a8ca4474aa4868721ea8709a2447.svg";
export { ForwardRef as ReactComponent };